import type { iCustomerPaymentReceipt } from "@sdk/bookings/booking-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { customerPaymentReceiptsDefaultQueryConfig } from "./customer-payment-receipts-default-query";

export const {
  slice: CustomerPaymentReceiptsSlice,
  reducers: CustomerPaymentReceiptsSliceReducer,
  actions: {
    setEntityQueryResults: setCustomerPaymentReceiptsQueryResults,
    setEntity: setCustomerPaymentReceipt,
    setEntities: setCustomerPaymentReceipts,
    patchEntity: patchCustomerPaymentReceipt,
    addNewEntity: addNewCustomerPaymentReceipt,
    setEntityFetchingStatus: setCustomerPaymentReceiptFetchingStatus,
    setEntitiesFetchingStatus: setCustomerPaymentReceiptsFetchingStatus,
    setEntityFailedStatus: setCustomerPaymentReceiptFailedStatus,
    setEntityQueryError: setCustomerPaymentReceiptsQueryError,
    resetQuery: resetCustomerPaymentReceiptsQuery,
    setQueryList: setCustomerPaymentReceiptQueryList,
  },
} = CreateEntitySlice<iCustomerPaymentReceipt>({
  sliceName: "customerPaymentReceipts",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...customerPaymentReceiptsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
